const defaultState = {
  aux: {},
  defaultSchemas: {},
};
export default (state = defaultState, action) => {
  const newState = Object.assign({}, state);
  const { payload, params, type } = action;
  switch (type) {
    case 'ADD_SCHEMA_TABLE':{
      if (!payload) throw new Error('Missing flowId');
      const newSchema = JSON.parse(JSON.stringify(newState.defaultSchemas[payload]));

      // only update aux if is the last table object form the defaultSchemas[payload]
      newState.aux[payload]++;
      newSchema.forEach((schema) => (schema.table = `${schema.table}_${newState.aux[payload]}`));

      newState[payload] = [...newState[payload], ...newSchema];
      return newState;
    }
    case 'CLOSE_WIDGET':
      newState.aux = {};
      return newState;
    case 'LOAD_MAPPING':{

      const { flowId: flow } = params;

      const addedSuffixes = new Set();
      const mappingKeys = Object.keys(payload);

      mappingKeys.forEach((mappingKey) => {
        const schemaTable = mappingKey.split('/')[0];
        // Table names can be "Base_Table" or "BaseTable_2", "Base_Table_3", etc.
        const suffixMatch = schemaTable.match(/_(\d+)$/);
        const tableSuffix = suffixMatch ? parseInt(suffixMatch[1], 10) : NaN;

        const shouldAddSchemaCopy = Number.isInteger(tableSuffix) && tableSuffix > 1 && !addedSuffixes.has(tableSuffix);
        if (!shouldAddSchemaCopy) return;

        const copiedSchemas = JSON.parse(JSON.stringify(newState.defaultSchemas[flow]));
        copiedSchemas.forEach((schema) => {
          // Keep the default schema table name as-is; it can legitimately end with digits.
          schema.table = `${schema.table}_${tableSuffix}`;
        });

        newState[flow] = [...newState[flow], ...copiedSchemas];
        addedSuffixes.add(tableSuffix);
      });

      // Keep aux aligned with the largest table suffix found in the persisted mapping.
      const highestAddedSuffix = addedSuffixes.size ? Math.max(...addedSuffixes) : null;
      newState.aux[flow] = highestAddedSuffix ?? (newState.aux[flow] ?? 1);

      return newState;

    }
    case 'SET_SCHEMA':{
      const { flowId, schema } = payload;
      const mappedSchema = schema.map(({ fields, table, type = undefined, required = false }) => ({
        table,
        required,
        type,
        fields: fields.map(({ name, id, type = undefined, required = false }) => ({
          id: String(id),
          name: name.trim(),
          type,
          required
        })),
      }));

      newState[flowId] = mappedSchema;
      newState.defaultSchemas[flowId] = mappedSchema;

      // update aux based on tables and flowId
      if (!newState.aux[flowId]) newState.aux[flowId] = 1;

      return newState;
    }
  }

  return state;
};
